import { IssueTaskDoc, IssueTaskStatus } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeIssueTasks } from 'src/utils/firebase/firebase-short-cut';

const useIssueTasksForCase = (caseId: string | undefined) => {
  const [issueTasks, setIssueTasks] = useState<IssueTaskDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (caseId) {
      setIsLoading(true);
      const subscription = observeIssueTasks([
        ['issueCaseId', '==', caseId],
        [
          'status',
          'in',
          [
            IssueTaskStatus.PENDING,
            IssueTaskStatus.OPEN,
            IssueTaskStatus.IN_PROGRESS,
            IssueTaskStatus.FAILED,
            IssueTaskStatus.COMPLETED,
            IssueTaskStatus.CANCELED,
          ],
        ],
      ]).subscribe((docs) => {
        setIssueTasks(docs);
        setIsLoading(false);
      });
      return () => subscription.unsubscribe();
    } else {
      setIssueTasks([]);
      setIsLoading(false);
    }
  }, [caseId]);

  return {
    issueTasks,
    isLoading,
  };
};

export default useIssueTasksForCase;
